import React, { useMemo } from 'react';
import { Modal, Typography, IconHighlight } from '@ann/web-components';
import { useMediaQueries } from '../../../../../../../utils/mediaQueries';
import { TitleWrapper, NextBestActionModalGlobalStyles, ModalBodyScroll } from './NextBestActionModal.styled';

/**
 * Modal that displays the full "Next best action" content.
 * Responsive width: 900px (desktop), 70% (tablet/iPad), 90% (mobile).
 * Height and max-height: 500px. Body scroll triggers at 450px.
 */
const NextBestActionModal = ({ isOpen, onClose, nextBestAction }) => {
  const { isDesktop, isTablet, isIpadAirPortrait, isIpadAirLandscape, isIpadProPortrait, isIpadProLandscape, isMobile } = useMediaQueries();

  const modalWidth = useMemo(() => {
    if (isDesktop) return '900px';
    if (isTablet || isIpadAirPortrait || isIpadAirLandscape || isIpadProPortrait || isIpadProLandscape) return '70%';
    if (isMobile) return '90%';
    return '90%';
  }, [isDesktop, isTablet, isIpadAirPortrait, isIpadAirLandscape, isIpadProPortrait, isIpadProLandscape, isMobile]);

  return (
    <>
      <NextBestActionModalGlobalStyles />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="medium"
        width={modalWidth}
        className="next-best-action-modal"
      >
        <Modal.Header>
          <Modal.Header.Title>
            <TitleWrapper>
              <IconHighlight
                bgColor="Purple"
                icon="aiChat"
                iconColor="Success"
                size="small"
              />
              <Typography category="subtitle" size="medium" weight="bold" color="body">
                Next best action
              </Typography>
            </TitleWrapper>
          </Modal.Header.Title>
        </Modal.Header>
        <Modal.Body align="left">
          <ModalBodyScroll>
            <Typography category="body" size="medium" weight="regular" color="body">
              {nextBestAction}
            </Typography>
          </ModalBodyScroll>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NextBestActionModal;
